import type { Agent } from '../types';

export type AppUserRecord = {
  id: string;
  username: string;
  displayName: string;
  nickname?: string;
  profileEmail?: string;
  avatar?: string;
  enabled?: boolean;
  smtp?: {
    mailFrom?: string;
    hasSmtpPassword?: boolean;
  };
};

export function appUserToAgent(u: AppUserRecord): Agent {
  const email =
    u.profileEmail?.trim() ||
    u.smtp?.mailFrom?.trim() ||
    '';
  return {
    id: u.id,
    name: u.displayName?.trim() || u.username,
    nickname: u.nickname?.trim() || u.username,
    email,
    avatar: u.avatar?.trim() || undefined,
  };
}

export function agentFromPublicProfile(p: Agent): Agent {
  return {
    id: p.id,
    name: p.name,
    nickname: p.nickname,
    email: p.email,
    avatar: p.avatar,
  };
}
